import { create } from "zustand";

interface SystemAlert {
  id: string;
  type: "error" | "warning" | "info" | "success";
  title: string;
  message: string;
  timestamp: number;
  dismissed: boolean;
}

interface AlertState {
  alerts: SystemAlert[];
  unacknowledgedCount: number;
  addAlert: (alert: Omit<SystemAlert, "id" | "timestamp" | "dismissed">) => void;
  dismissAlert: (id: string) => void;
  clearAll: () => void;
  setUnacknowledgedCount: (count: number) => void;
}

export const useAlertStore = create<AlertState>((set) => ({
  alerts: [],
  unacknowledgedCount: 0,

  addAlert: (alert) =>
    set((state) => ({
      alerts: [
        {
          ...alert,
          id: crypto.randomUUID(),
          timestamp: Date.now(),
          dismissed: false,
        },
        ...state.alerts,
      ].slice(0, 50), // Keep at most 50 alerts
    })),

  dismissAlert: (id) =>
    set((state) => ({
      alerts: state.alerts.map((a) =>
        a.id === id ? { ...a, dismissed: true } : a,
      ),
    })),

  clearAll: () => set({ alerts: [] }),

  setUnacknowledgedCount: (count) => set({ unacknowledgedCount: count }),
}));
